import React from "react";
import Table from "../../../../core/pagination/datatable";
import { useSelector } from "react-redux";
import { Select } from "antd";
const TicketsTable = () => {
  const dataSource = useSelector((state) => state.rootReducer.CRMTickets);

  console.log(dataSource);
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
    },
    {
      title: "Subject",
      dataIndex: "subject",
      sorter: (a, b) => a.subject.length - b.subject.length,
      render: (contact) =>
        contact.length > 15 ? `${contact.substring(0, 15)}...` : contact,
    },

    {
      title: "Department",
      dataIndex: "department",
      sorter: (a, b) => a.department.length - b.department.length,
    },
    {
      title: "Service",
      dataIndex: "service",
      sorter: (a, b) => a.service.length - b.service.length,
    },
    {
      title: "Contact",
      dataIndex: "contact",
      sorter: (a, b) => a.contact.length - b.contact.length,
      render: (contact) =>
        contact.length > 15 ? `${contact.substring(0, 15)}...` : contact,
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a, b) => a.status.length - b.status.length,
      render: (status) => {
        let badgeClass = "";

        switch (status.toLowerCase()) {
          case "open":
            badgeClass = "badge bg-soft-primary"; // Blue
            break;
          case "closed":
            badgeClass = "badge bg-soft-secondary"; // Gray
            break;
          case "in progress":
            badgeClass = "badge bg-soft-warning text-dark"; // Orange
            break;
          case "answered":
            badgeClass = "badge bg-soft-success"; // Green
            break;
          case "on hold":
            badgeClass = "badge bg-soft-danger"; // Red
            break;
          default:
            badgeClass = "badge bg-soft-secondary"; // Default Gray
        }

        return <span className={badgeClass}>{status}</span>;
      },
    },

    {
      title: "Priority",
      dataIndex: "priority",
      sorter: (a, b) => a.priority.length - b.priority.length,
    },
    // {
    //   title: "Last Reply",
    //   dataIndex: "last_reply",
    //   sorter: (a, b) => a.last_reply.length - b.last_reply.length,
    // },
    {
      title: "Created",
      dataIndex: "created",
      sorter: (a, b) => a.created.length - b.created.length,
      render: (created) => created.split(" ")[0],
    },
  ];

  const options = [
    { value: "all", label: "All" },
    { value: "assigned", label: "Tickets assigned to me" },
    { value: "merged", label: "Merged" },
    { value: "open", label: "Open" },
    { value: "in_progress", label: "In Progress" },
    { value: "answered", label: "Answered" },
    { value: "on_hold", label: "On Hold" },
    { value: "closed", label: "Closed" },
  ];

  return (
    <div className="card table-list-card">
      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
        <div className="search-set"></div>
        <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
          <Select
            style={{ width: 200 }}
            placeholder="Select Ticket Status"
            options={options}
          />
        </div>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <Table columns={columns} dataSource={dataSource} />
        </div>
      </div>
    </div>
  );
};

export default TicketsTable;
